import { styled, xStyledCommonProps } from '@elliemae/ds-system';
import {
  DSFormLayoutCheckboxGroupName,
  FORM_LAYOUT_CHECKBOX_GROUP_SLOTS,
} from './DSFormLayoutCheckboxGroupDefinitions.js';

type DirectionsT = 'horizontal' | 'vertical';

interface DSControlledCheckboxGroupStyledContainerT {
  direction: DirectionsT;
}

export const StyledContainer = styled('div', {
  name: DSFormLayoutCheckboxGroupName,
  slot: FORM_LAYOUT_CHECKBOX_GROUP_SLOTS.ROOT,
})<DSControlledCheckboxGroupStyledContainerT>`
  display: inline-flex;
  flex-wrap: wrap;
  flex-direction: ${({ direction }) => (direction === 'horizontal' ? 'row' : 'column')};
  margin-left: ${({ theme }) => theme.space.xs};
  margin-right: ${({ theme }) => theme.space.xs};
  margin-top: ${({ theme }) => theme.space.xxs};
  & div:not([role='checkbox']) {
    padding: 0;
    margin-bottom: ${({ theme }) => theme.space.xxs};
  }
  & div:not(:last-child) {
    margin-right: ${({ theme, direction }) => (direction === 'horizontal' ? theme.space.s : '0')};
  }
  ${xStyledCommonProps}
`;
